export const messages = {
  title: 'Wallets',
  activateWalletError: 'Unable to activate wallet. Please try again later.',
  activateWalletSuccess: 'Wallet was activated',
  deactivateWalletError: 'Unable to deactivate wallet. Please try again later.',
  deactivateWalletSuccess: 'Wallet was deactivated',
  archiveWalletError: 'Unable to archive wallet. Please try again later.',
  archiveWalletSuccess: 'Wallet was archived',
  unarchiveWalletError: 'Unable to unarchive wallet. Please try again later.',
  unarchiveWalletSuccess: 'Wallet was unarchived',
};
